import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '../../molecules';
import {
  Description,
  Headline,
  HeadlineContent,
  HeadlineContainer,
  StyledMoneyBack,
  Line,
  IconContainer,
} from './styles.js';
import pawIcon from './icon.svg';
import stripeInfo from './stripe-info.svg';

export const MoneyBack = ({ headline, description }) => {
  return (
    <StyledMoneyBack>
      <HeadlineContainer>
        <IconContainer>
          <ResponsiveImage
            src={pawIcon}
            alt="Stamp with a pup paw with a heart's shape"
            height={74}
            width={64}
          />
        </IconContainer>
        <HeadlineContent>
          <Headline>{headline}</Headline>
          <Description>{description}</Description>
        </HeadlineContent>
      </HeadlineContainer>
      <Line />
      <ResponsiveImage
        src={stripeInfo}
        alt="Lock icon and the text Security powered by Stripe"
        height={21}
        width={191}
      />
    </StyledMoneyBack>
  );
};
MoneyBack.displayName = 'MoneyBack';
MoneyBack.propTypes = {
  headline: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
